@if ((facetList$ | async)?.facets; as facets) {
    <section
        class="inner"
        [attr.aria-label]="'productFacetNavigation.filterBy.facet' | cxTranslate"
        [cxFocus]="isDialog ? dialogFocusConfig : {}"
        [tabindex]="-1"
        (click)="block($event)">
        <div class="bg-petrol-light d-block d-md-none p-3">
            <i class="aimo-icon icon-petrol-blue icon-inline icon-arrow-left mr-3 icon-cursor" (click)="close()"> </i>
            <h4 class="text-primary mb-0 d-inline">{{ 'productList.filter.button' | cxTranslate }}</h4>
        </div>
        <!--
        Here we'd like to introduce configurable facet components,
        either by using specific configuration or generic sproutlets
        -->
        @for (facet of facets; track facet) {
            @if (isFacetAllowed(facet)) {
                <aimo-facet
                    [mobileUI]="mobileUI"
                    (selectedQueryTerms)="setFacetTermsForMobile($event)"
                    [closeFacet]="openFacet.asObservable()"
                    (openFacet)="triggerOpenFacet($event)"
                    #facetRef
                    [facet]="facet"
                    class="collapsed"
                    role="group"
                    attr.aria-label="{{
                'productFacetNavigation.ariaLabelItemsAvailable'
                    | cxTranslate
                        : {
                              name: facet.name,
                              count: facet?.values?.length,
                          }
            }}"></aimo-facet>
            }
        }
    </section>
}
